export default "__VITE_ASSET__BQVmsYIQ__"